import { render } from "./ModalDates.vue?vue&type=template&id=52e7c041&scoped=true"
import script from "./ModalDates.vue?vue&type=script&lang=js"
export * from "./ModalDates.vue?vue&type=script&lang=js"

import "./ModalDates.vue?vue&type=style&index=0&id=52e7c041&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e7c041"]])

export default __exports__